import { Component, Input, inject, input, output } from '@angular/core';

import { IncompleteGpAddressTableData, GpAddressStatus } from '../../../../../types/gp-letters';
import { GpAddressesApiService } from '../../../../../api/admin/orders/gpaddresses/gp-addresses.service';

@Component({
    selector: 'status-update-button',
    imports: [],
    templateUrl: './status-update.component.html',
    styleUrl: './status-update.component.scss'
})
export class StatusUpdateComponent {
  private gpAddressesApiService = inject(GpAddressesApiService);

  readonly address = input<IncompleteGpAddressTableData | null>(null);
  readonly label = input('');
  readonly toggledLabel = input('');
  @Input() toggleStatus: GpAddressStatus = GpAddressStatus.verified;
  readonly defaultStatus = input<GpAddressStatus>(GpAddressStatus.verified);
  readonly addressVerifiedEvent = output<void>();
  protected readonly GpAddressStatus = GpAddressStatus;

  setAddressStatus(status_id: GpAddressStatus) {
    const address = this.address();
    if (address) {
      address.clone.status_id = status_id;
      this.gpAddressesApiService
        .putUpdateAddresses$(address.gpaddress_id, address.clone)
        .subscribe(({ data }) => {
          const addressValue = this.address();
          if (addressValue) {
            addressValue.status_id = data.attributes.status_id;
            this.addressVerifiedEvent.emit();
          }
        });
    }
  }
}
